

















import { Vue, Component, Watch } from 'vue-property-decorator';
import ItemTable from '@/components/common/ItemTable.vue';

import { namespace } from 'vuex-class';
import { GetStatisticsMembersByPeriod } from 'supporter';
import { QueryOption } from '@/types/memberStatistic';
import { formatCurrency } from '@/utils/formatUtils';
import { i18nInObjectList } from '@/utils/i18n';
const statisticModule = namespace('memberStatistic');

@Component({
  components: {
    ItemTable,
  },
})
export default class MemberStatusGrid extends Vue {
  @statisticModule.State('statisticMembersByPeriodResponse')
  private statisticMembersByPeriodResponse!: GetStatisticsMembersByPeriod;
  @statisticModule.State('queryOption')
  private queryOption!: QueryOption;
  @statisticModule.Mutation('SET_PAGE') public setPage!: (page: number) => void;
  @statisticModule.Mutation('SET_PAGE_SIZE') public setPageSize!: (
    pageSize: number,
  ) => void;

  private statisticMembersPeriodContent: any[] = [];

  gridResult = {
    header: {
      height: 65,
      complexColumns: [
        {
          header: 'STATISTIC_MEMBER_GENDER',
          name: 'sex',
          childNames: ['maleMembers', 'femaleMembers', 'unclassifiedMembers'],
        },
        {
          header: 'STATISTIC_MEMBER_PLATFORM',
          name: 'platform',
          childNames: [
            'membersJoinedByPc',
            'membersJoinedByMobileweb',
            'membersJoinedByMobileapp',
          ],
        },
      ],
    },
    columns: [
      {
        header: 'STATISTIC_MEMBER_DIVISION',
        name: 'date',
        align: 'center',
        minWidth: 130,
      },
      {
        header: 'STATISTIC_MEMBER_MEMBER_COUNT',
        name: 'totalMemberCount',
        width: 130,
        align: 'center',
      },
      {
        header: 'STATISTIC_MEMBER_SHOPPING_MALL',
        name: 'mallMembers',
        width: 130,
        align: 'center',
      },
      {
        header: 'STATISTIC_MEMBER_MALE',
        name: 'maleMembers',
        width: 130,
        align: 'center',
      },
      {
        header: 'STATISTIC_MEMBER_FEMALE',
        name: 'femaleMembers',
        width: 130,
        align: 'center',
        formatter: function(cell: any) {
          return formatCurrency(cell.value);
        },
      },
      {
        header: 'STATISTIC_MEMBER_UNCLASSIFIED',
        name: 'unclassifiedMembers',
        width: 130,
        align: 'center',
        formatter: function(cell: any) {
          return formatCurrency(cell.value);
        },
      },
      {
        header: 'STATISTIC_MEMBER_PLATFORM_TYPE_PC',
        name: 'membersJoinedByPc',
        width: 130,
        align: 'center',
        formatter: function(cell: any) {
          return formatCurrency(cell.value);
        },
      },
      {
        header: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_WEB',
        name: 'membersJoinedByMobileweb',
        width: 130,
        align: 'center',
        formatter: function(cell: any) {
          return formatCurrency(cell.value);
        },
      },
      {
        header: 'STATISTIC_MEMBER_PLATFORM_TYPE_MOBILE_APP',
        name: 'membersJoinedByMobileapp',
        width: 128,
        align: 'center',
        formatter: function(cell: any) {
          return formatCurrency(cell.value);
        },
      },
    ],
    options: {
      columnOptions: {
        minWidth: 130,
        resizable: true,
      },
      rowHeight: 35,
      minRowHeight: 35,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0,
      },
    },
  };
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
  };

  get totalCount(): number {
    return this.queryOption ? this.queryOption.totalCount : 0;
  }

  @Watch('queryOption', { immediate: false, deep: true })
  fetchPageOption() {
    this.gridResult.options.pageOptions.page = this.queryOption.page;
    this.gridResult.options.pageOptions.perPage = this.queryOption.pageSize;
    this.gridResult.options.pageOptions.totalCount = this.queryOption.totalCount;
  }

  @Watch('statisticMembersByPeriodResponse', { immediate: false, deep: true })
  ifStatisticMembersByPeriodResponse() {
    this.statisticMembersPeriodContent = this.statisticMembersByPeriodResponse.contents.map(
      (content: any) => {
        return {
          ...content,
          mallMembers: content.memberType.mallMemberCount,
          maleMembers: content.gender.maleMemberCount,
          femaleMembers: content.gender.femaleMemberCount,
          unclassifiedMembers: content.gender.unclassifiedMemberCount,
          membersJoinedByPc: content.joinRoute.pcMemberCount,
          membersJoinedByMobileweb: content.joinRoute.mobileWebMemberCount,
          membersJoinedByMobileapp: content.joinRoute.mobileAppMemberCount,
        };
      },
    );
  }

  created() {
    this.gridResult = i18nInObjectList(
      this,
      this.gridResult,
      'columns',
      'header',
    );
    this.gridResult.header = i18nInObjectList(
      this,
      this.gridResult.header,
      'complexColumns',
      'header',
    );
  }

  changePageOption(page: number, pageSize: number = 30) {
    this.setPage(page);
    this.setPageSize(pageSize);
    this.$emit('changeQuery');
  }
}
